var initSubscribe = function(){
    var button = $('.subscribe');
    var icon = button.find('.mdi');
    var text = button.find('span');
    var data = button.data();
    button.click(function(){
        if(!parseInt($('#f-user_id').val())){
            showLoginPopup();
            return false;
        }

        if(button.hasClass('is-inactive')){
            button.removeClass('is-inactive');
            icon.removeClass('mdi-bell-outline').addClass('mdi-bell-ring');
            text.text(data.activeMessage);
            var action = 'add';
        } else {
            button.addClass('is-inactive');
            icon.removeClass('mdi-bell-ring').addClass('mdi-bell-outline');
            text.text(data.inactiveMessage);
            var action = 'remove';
        }

        $.post('/tracking/' + action, button.data());
        return false;
    })
}


var comments = window.comments = {

    url: '/comments',

    userId: 0,

    isShowAll:false,

    init: function(url){
        this.url = url;

        var forms = $('.com-form');
        forms.each(function(i, form){
            this.initForm($(form));
        }.bind(this));

        // this.initForm(form);
        this.initComments($('.comment'));
        this.userId = parseInt($('#f-user_id').val());

        this.initShowAll();

        this.initFromNotifications();


    },

    initFromNotifications: function(){
        var hash = window.location.hash;
        if(hash == '#new-comments') {
            $('#show-all-comments-link').click();
        }
    },

    initShowAll: function(){
        var link = $('#show-all-comments-link');
        link.click(function(){
            link.addClass('is-loading');
            $.get( link.data('url'), function(data){
                var section = $('#comments-section');
                var top = section[0].getBoundingClientRect().top;
                if(top < 0){
                    section[0].scrollIntoView({block: 'start',behavior: "smooth"});
                }

                section.replaceWith(data);
                comments.init('/comments');
                unreadScroller.init();
                initSubscribe();
                comments.isShowAll = true;
            });
            return false;
        })
    },



    initComments: function(com) {
        if(this.url == '/comments'){
            this.initQuote(com);
        } else {
            this.initForumQuote(com);
        }

        this.initEdit(com);
        this.initDelete(com);
        this.initVotes(com);
        this.initAbuse(com);
        this.initTop(com);
    },

    checkUser: function(){
        if(comments.userId == 0){
            showLoginPopup();
            document.body.style.minHeight = '500px' ;
            window.parent.postMessage({sentinel: 'amp', type: 'embed-size', height: document.body.scrollHeight,},'*');

            return false;
        }
        return true;

    },

    initVotes: function(com){
        var that = this;
        com.find('.vote-up, .vote-down').click(function(){
            var link = $(this);
            var comId = link.parent().data('id');
            var action = link.hasClass('vote-up') ? 'up' : 'down';
            $.post(that.url + '/' + comId + '/vote-' + action);
            var num = link.find('.num');
            var val = parseInt(num.text()) || 0;
            num.text(val + 1);
            link.addClass('voted');
            link.parent().addClass('voted');
        });
    },

    initAbuse(com){
        com.find('.dropdown-trigger').click(function(){
            var trigger = $(this);
            var dropdown = trigger.closest('.dropdown');
            dropdown.toggleClass('is-active');
            if(dropdown.hasClass('is-active')){
                $('body').one('click', function(){
                    dropdown.removeClass('is-active');
                });
            }
            return false;
        })

        com.find('.comment-abuse-link').click(function(){
            var dropdown = $(this).closest('.dropdown');
            dropdown.removeClass('is-active');
            console.log($(this).data());

            $.magnificPopup.open({
                items: { src: '/abuse',   type: 'ajax' },
                ajax: { settings: {  data: $(this).data()}}
            });

            return false;
        });
    },

    initTop: function(com){
        com.find('.comment-top-link').click(function(){
            var dropdown = $(this).closest('.dropdown');
            dropdown.removeClass('is-active');
            var action = $(this).data('action');
            var container = $(this).closest('.com');

            $.post(action, function(data){
                var newCom = $(data);
                comments.initComments(newCom);
                container.replaceWith(newCom.find('.com'));
                if(! comments.isShowAll){
                    window.location.reload();
                }
            });
        })
    },

    initEdit: function(com) {
        var that = this;
        com.find('.edit').click(function(){
            var link = $(this);
            var comId = link.data('id');
            var container = link.closest('.com');
            $.get(that.url + '/' + comId, function(data){
                var formContainer = $(data);
                container.before(formContainer);
                container.hide();

                var form = formContainer.find('form');
                var textarea = form.find('textarea').focus();
                var cancelLink = form.find('.cancel');

                autosize(textarea);

                cancelLink.click(function(){
                    formContainer.remove();
                    container.show();
                    return false;
                });

                form.submit(function(){
                    $.post(that.url + '/' + form.data('id'), form.serializeArray(), function(data){
                        var newCom = $(data);
                        comments.initComments(newCom);
                        formContainer.remove();
                        container.replaceWith(newCom.find('.com'));


                    });
                    return false;
                });
            })
            return false;
        });
    },

    initDelete: function(com){
        var that = this;
        com.find('.delete').click(function(){
            var link = $(this);
            var comId = link.data('id');
            if(confirm('Czy napewno usunąć?')){
                $.post(that.url + '/' + comId + '/delete', function(data){
                    link.closest('.com').replaceWith(data);
                });
            }
        });
    },

    initForumQuote: function(com) {
        com.find('.quote').click(function(){
            if( comments.checkUser() == false){
                return;
            }
            $('.answer').show();
            var con = $(this).closest('.con');
            var login = con.find('.login').text();
            var message = con.find('.msg').clone();
            message.find('.cite').remove();
            message.find('blockquote').remove();
            message.find('p').append("\n");

            console.log(message.html());

            var text = message.text();
            text = $.trim(text);

            var textarea = $('.com-form textarea');
            textarea.val(textarea.val() + '[cytat='+login+']'+text+"[/cytat]\n\n");
            autosize.update(textarea);


            textarea[0].scrollIntoView({block: 'center',behavior: "smooth"});
            setTimeout(function(){
                textarea.focus();
                var t = textarea.get(0);
                t.selectionStart = t.selectionEnd = t.value.length;
            }, 1000);
        });
    },

    initQuote: function(com) {
        com.find('.quote').click(function(){
            if( comments.checkUser() == false){
                return;
            }

            var link = $(this);
            var parentId = link.data('id');
            var li = link.closest('li');
            var childrenList = li.find('.children:first');
            if(childrenList.length == 0){
                childrenList = $('<ul class="children"></ul>');
                li.append(childrenList);
            }

            var answerLi = link.data('answer-li');

            if(answerLi && answerLi.is(":visible" )){
                answerLi.remove();
                link.data('answer-li', null);
                return;
            }

            //set up form
            var newLi = $($('#comment-form-template').html());
            comments.initForm(newLi.find('form'));
            childrenList.prepend(newLi);
            newLi.find('textarea').focus();
            newLi.find('.f-parent_id').val(parentId);

            link.data('answer-li',newLi);
        });
    },

    initForm: function(form) {
        var that = this;
        var footer = form.find('.footer');
        var cancelLink = form.find('.cancel');
        var textarea = form.find('textarea').on('autosize:resized', function(){
            window.parent.postMessage({sentinel: 'amp', type: 'embed-size', height: document.body.scrollHeight,},'*');
        });

        textarea.focus(function(e){
            if( comments.checkUser() == false){
                this.blur();
                return false;
            }
            form.addClass('open');
            autosize(textarea);
        });

        cancelLink.click(function(){
            form.removeClass('open');
            autosize.destroy(textarea);

            if(form.closest('.children').length){
                form.closest('li').remove();
            }

            return false;
        });

        form.submit(function(){
            var data = form.serializeArray();

            form.lockForm();

            //lock TODO
            $.post(that.url + '/create', data, function(data){
                form.unlockForm();
                data = $(data);
                comments.initComments(data);

                if(comments.url == '/comments'){
                    var li = form.closest('li');
                    li.replaceWith(data);
                } else {
                    $('.comment-list').append(data);
                    textarea.val('');
                    autosize.update(textarea);
                    $('.answer').hide();
                }
            });
            return false;
        })
    }


}


// WEBPACK FOOTER //
// ./Resources/assets/js/comments.js